module.exports = __webpack_public_path__ + "img/warnings-08.d9ead1dc.png";